import React, { useState } from "react";
import { Collapse } from "react-bootstrap";

function RandomizerSidebar({ handleAddNewTab, checkActiveTab }) {
  const [openSites, setOpenSites] = useState(false);
  let studyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const iwrsPermissionData = JSON.parse(
    localStorage.getItem("iwrsPermissionData")
  );
  let siteManagementIWRS = iwrsPermissionData?.siteManagementIWRSDBP || iwrsPermissionData?.siteManagementIWRSQC || iwrsPermissionData?.siteManagementIWRSLive
  let treatmentManagementIWRS = iwrsPermissionData?.treatmentManagementIWRSDBP || iwrsPermissionData?.treatmentManagementIWRSQC || iwrsPermissionData?.treatmentManagementIWRSLive
  let auditTrialIWRS = iwrsPermissionData?.auditTrialIWRSDBP || iwrsPermissionData?.auditTrialIWRSQC || iwrsPermissionData?.auditTrialIWRSLive
  let factorIWRS = iwrsPermissionData?.factorIWRSDBP || iwrsPermissionData?.factorIWRSQC || iwrsPermissionData?.factorIWRSLive
  let trialDesignIWRS = iwrsPermissionData?.trialDesignIWRSDBP || iwrsPermissionData?.trialDesignIWRSQC || iwrsPermissionData?.trialDesignIWRSLive
  let randomizeIWRS = iwrsPermissionData?.randomizeIWRSDBP || iwrsPermissionData?.randomizeIWRSQC || iwrsPermissionData?.randomizeIWRSLive
  let approvalOneIWRS = iwrsPermissionData?.approvalOneIWRSQC || iwrsPermissionData?.approvalOneIWRSLive
  let approvalTwoIWRS = iwrsPermissionData?.approvalTwoIWRSQC || iwrsPermissionData?.approvalTwoIWRSLive
  let approvalThreeIWRS = iwrsPermissionData?.approvalThreeIWRSQC || iwrsPermissionData?.approvalThreeIWRSLive
  let approvalFourIWRS = iwrsPermissionData?.approvalFourIWRSQC || iwrsPermissionData?.approvalFourIWRSLive
  let approvalFiveIWRS = iwrsPermissionData?.approvalFiveIWRSQC || iwrsPermissionData?.approvalFiveIWRSLive
  let approvalAccess = approvalOneIWRS || approvalTwoIWRS || approvalThreeIWRS || approvalFourIWRS || approvalFiveIWRS || studyMode === "DBP MODE"

  return (
    <>
      <div className="link__tab">
        <div
          onClick={() => setOpenSites(!openSites)}
          aria-expanded={openSites}
          className={"text-start h-auto tab_url w-100"}
          style={{ background: "#ccd6dd" }}
        >
          <div className="hstack justify-content-between">
            <div>
              <i className={"me-2 ps-0 fa-solid  fa-folder"}></i>
              <span>StudyID</span>
            </div>
          </div>
        </div>
      </div>

      <Collapse in={true}>
        <div>
          {siteManagementIWRS &&
            <div
              className={`CP small link__tab ${checkActiveTab("siteList") && "selectedMenu"
                }`}
              onClick={() => {
                handleAddNewTab("Sites", "fa-solid fa-address-card", "siteList");
              }}
            >
              <div className="text-start h-auto tab_url w-100">
                <i className="fa-solid fa-building ps-2 me-2 small"></i>
                Site Management
              </div>
            </div>
          }
          {treatmentManagementIWRS &&
            <div
              className={`CP small link__tab ${checkActiveTab("treatmentManagement") && "selectedMenu"
                }`}
              onClick={() => {
                handleAddNewTab(
                  "Treatment Management",
                  "fa-solid fa-address-card",
                  "treatmentManagement"
                );
              }}
            >
              <div className="text-start h-auto tab_url w-100">
                <i className="fa-solid fa-building ps-2 me-2 small"></i>
                Treatment Management
              </div>
            </div>
          }
          {auditTrialIWRS &&
            <div
              className={`CP small link__tab ${checkActiveTab("auditTrial") && "selectedMenu"
                }`}
              onClick={() => {
                handleAddNewTab(
                  "Audit Trial",
                  "fa-solid fa-address-card",
                  "auditTrial"
                );
              }}
            >
              <div className="text-start h-auto tab_url w-100">
                <i className="fa-solid fa-building ps-2 me-2 small"></i>
                Audit Trail
              </div>
            </div>
          }
          {factorIWRS &&
            <div
              className={`CP small link__tab ${checkActiveTab("trialFactorDesign") && "selectedMenu"
                }`}
              onClick={() => {
                handleAddNewTab(
                  "Factor",
                  "fa-solid fa-address-card",
                  "trialFactorDesign"
                );
              }}
            >
              <div className="text-start h-auto tab_url w-100">
                <i className="fa-solid fa-building ps-2 me-2 small"></i>
                Factor
              </div>
            </div>
          }
          {trialDesignIWRS &&
            <div
              className={`CP small link__tab ${checkActiveTab("trialParameters") && "selectedMenu"
                }`}
              onClick={() => {
                handleAddNewTab(
                  "Trial Design",
                  "fa-solid fa-address-card",
                  "trialParameters"
                );
              }}
            >
              <div className="text-start h-auto tab_url w-100">
                <i className="fa-solid fa-building ps-2 me-2 small"></i>
                Trial Design
              </div>
            </div>
          }
          {randomizeIWRS &&
            <div
              className={`CP small link__tab ${checkActiveTab("randomizeId") && "selectedMenu"
                }`}
              onClick={() => {
                handleAddNewTab(
                  "Randomize",
                  "fa-solid fa-shuffle ",
                  "randomizeId"
                );
              }}
            >
              <div className="text-start h-auto tab_url w-100">
                <i className="fa-solid fa-shuffle  ps-2 me-2 small"></i>
                Randomize
              </div>
            </div>
          }
          <div
            className={`CP small link__tab ${checkActiveTab("requestManagement") && "selectedMenu"
              }`}
            onClick={() => {
              handleAddNewTab(
                "Request Management",
                "fa-solid fa-address-card",
                "requestManagement"
              );
            }}
          >
            <div className="text-start h-auto tab_url w-100">
              <i className="fa-solid fa-building ps-2 me-2 small"></i>
              Request Management
            </div>
          </div>
          {/* <div className="link__tab">
            <div
              className={`text-start h-auto tab_url w-100 ${openRandomizations === true ? "sidebar__active" : ""
                }`}
              onClick={() => setOpenRandomizations(!openRandomizations)}
              aria-expanded={openRandomizations}
            >
              <div className="hstack justify-content-between">
                <div>
                  <i
                    className={`me-2 ps-2 fa-solid ${!openRandomizations === true
                        ? "fa-dice-six"
                        : "fa-dice-one"
                      }`}
                  ></i>
                  <span>Randomization</span>
                </div>
                <i
                  className={`fa-solid ${openRandomizations === true
                      ? "fa-angle-down"
                      : "fa-angle-right"
                    }`}
                ></i>
              </div>
            </div>
          </div>
          <Collapse in={openRandomizations}>
            <div>
              <div className="link__tab">
                <div
                  className={`text-start h-auto tab_url w-100 ${openTrialDesign === true ? "sidebar__active" : ""
                    }`}
                  onClick={() => setOpenTrialDesign(!openTrialDesign)}
                  aria-expanded={openTrialDesign}
                >
                  <div className="hstack justify-content-between">
                    <div>
                      <i
                        className={`me-2 ps-3 fa-solid ${!openTrialDesign === true
                            ? "fa-dice-six"
                            : "fa-dice-one"
                          }`}
                      ></i>
                      <span>Trial Design</span>
                    </div>
                    <i
                      className={`fa-solid ${openTrialDesign === true
                          ? "fa-angle-down"
                          : "fa-angle-right"
                        }`}
                    ></i>
                  </div>
                </div>
              </div>
              <Collapse in={openTrialDesign}>
                <div>
                  <div
                    className={`CP small link__tab ${checkActiveTab("treatmentDesign") && "selectedMenu"
                      }`}
                    onClick={() => {
                      handleAddNewTab(
                        "Treatments",
                        "fa-solid fa-address-card",
                        "treatmentDesign"
                      );
                    }}
                  >
                    <div className="text-start h-auto tab_url w-100">
                      <i className="fa-solid fa-building ps-4 me-2 small"></i>
                      Treatments
                    </div>
                  </div>

                  <div
                    className={`CP small link__tab ${checkActiveTab("trialFactorDesign") && "selectedMenu"
                      }`}
                    onClick={() => {
                      handleAddNewTab(
                        "Factors",
                        "fa-solid fa-address-card",
                        "trialFactorDesign"
                      );
                    }}
                  >
                    <div className="text-start h-auto tab_url w-100">
                      <i className="fa-solid fa-building ps-4 me-2 small"></i>
                      Factors
                    </div>
                  </div>

                
                </div>
              </Collapse>
            
            </div>
          </Collapse> */}
        </div>
      </Collapse>
    </>
  );
}

export default RandomizerSidebar;
